// test1048
(1048 && 0);
